<template>
  <div v-if="tab == 1">
    <div
      style="
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 1.7rem 0 1rem 0;
      "
    >
      <img
        src="../assets/img/wanfang.jpg"
        style="width: 1.8rem; height: 1.8rem; border-radius: 50%"
      />
      <div
        style="
          font-size: 0.6rem;
          color: #7e8184;
          margin-left: 0.1rem;
          letter-spacing: 3px;
        "
      >
        万方论文检测
      </div>
    </div>
    <div
      style="
        display: flex;
        align-items: center;
        padding: 0 0.6rem;
        height: 1rem;
      "
    >
      <van-field
        v-model="tel"
        type="tel"
        placeholder="请输入电话号码查询订单"
        maxlength="11"
        style="border: 1px solid #333; height: 100%; border-right: none"
      />
      <div
        style="
          width: 2.3rem;
          height: 100%;
          background: #f8f8f8;
          border: 1px solid #333;
          border-left: none;
          color: #222;
          text-align: center;
          line-height: 1rem;
          font-size: 15px;
          letter-spacing: 3px;
          font-weight: bold;
        "
        @click="toQuery"
      >
        查询
      </div>
    </div>
  </div>
  <div v-else>
    <div>
      <van-sticky>
        <van-search
          v-model="value"
          shape="round"
          background="#228ef7"
          placeholder="请输入手机号查询订单"
          clearable
        >
        </van-search>
        <van-notice-bar
          left-icon="info-o"
          text="点击联系在线客服"
          mode="closeable"
          @click="toKf"
        />
      </van-sticky>
      <div></div>
      <div>
        <div class="box" v-for="msg in msgs" :key="msg.id" @click="allbox(msg)">
          <div class="box-title">
            <div>
              <span class="box-title-order">订单号</span>
              <span class="box-title-num">{{ msg.orderid }}</span>
            </div>
            <span class="box-title-status">{{
              msg.status == "待支付" ? "待提交" : msg.status
            }}</span>
          </div>
          <div class="box-content">
            <span class="box-content-title">{{ msg.title }}</span>
            <div class="box-content-order">
              <div class="box-content-timer">{{ getCategoryName(msg.category) }}</div>
              <div class="box-content-timer">
                时间：
                <span>{{ msg.created_at }}</span>
              </div>
            </div>
          </div>
          <div class="box-bottom">
            <span class="box-bottom-price">￥{{ msg.price }}</span>
            <div v-if="msg.status == '检测完成'">
              <div class="reportstyle">查看报告</div>
            </div>
            <div v-else>
              <div class="paystyle" style="background: #fd5632">查看报告</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast, Dialog } from "vant";
import { formatVersionName } from "@/utils/order";

export default {
  data() {
    return {
      msgs: [],
      value: "",
      tab: 1,
      tel: "",
    };
  },
  watch: {
    tab(e) {
      if (e == 2) {
        document
          .querySelector(".app")
          .setAttribute("style", "background-color:#F3F4F6");
        return;
      }
      if (e == 1) {
        document
          .querySelector(".app")
          .setAttribute("style", "background-color:#fff");
      }
    },
    value(e) {
      if (!e) {
        this.tab = 1;
      } else {
        this.tab = 2;
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    document
      .querySelector(".app")
      .setAttribute("style", "background-color:#fff");
    next();
  },
  beforeRouteLeave(to, from, next) {
    document
      .querySelector(".app")
      .setAttribute("style", "background-color:#f5f5f5");
    next();
  },
  created() {
    let isphone = this.getUrlParam("phone");
    //赋值电话
    if (isphone) {
      this.tab = 2;
      this.tel = isphone;
      this.initData();
    }
  },
  methods: {
    getUrlParam(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    toKf() {
      console.log("xix");
      window.location.href =
        "https://chatbot.weixin.qq.com/webapp/Ws75Px9atGV9s4UkR64nosl5FI8L7b?isFloat=false&robotName=%E4%B8%87%E6%96%B9%E5%9C%A8%E7%BA%BF%E5%AE%A2%E6%9C%8D";
    },
    initData() {
      this.$http.getNoLoginOrder(this.tel).then((res) => {
        if (res.data.length == 0) {
          this.value = this.tel;
          Dialog.confirm({
            title: "查不到此手机号码订单",
            message: "请登录系统后查看",
          })
            .then(() => {
              window.location.href = "http://m.wanfangtest.com/p";
            })
            .catch(() => {
              console.log("取消");
            });
        }
        if (res.data.length > 0) {
          this.tab = 2;
          this.msgs = res.data;
          this.value = this.tel;
        }
      });
    },
    toQuery() {
      if (!/^1[23456789]\d{9}$/.test(this.tel)) {
        Toast("请输入正确手机号");
        return false;
      }
      this.initData();
    },
    toPay(payMsg) {
      this.$router.push({
        path: "/pay",
        query: {
          id: payMsg.id,
          title: payMsg.title,
          writer: payMsg.writer,
          words: payMsg.words,
          price: payMsg.price,
          orderid: payMsg.orderid,
          name: this.getCategoryName(payMsg.category),
          timer: payMsg.created_at,
          pricetype: payMsg.category && payMsg.category.price_type,
        },
      });
    },
    getCategoryName(category) {
      return formatVersionName(category) || "未分类";
    },
    allbox(msg) {
      if (msg.status == "排队中" || msg.status == "检测中") {
        Toast("该论文正在检测中，如长时间未出结果，请联系客服处理。");
        return;
      }
      if (msg.status == "暂停") {
        Toast("该订单被设置暂停检测，请联系客服处理");
        return;
      }
      if (msg.status == "待支付") {
        this.toPay(msg);
      }
      if (msg.status == "检测完成") {
        this.toResult(msg);
      }
    },
    toResult(msg) {
      let id = msg.id;
      let orderid = msg.orderid;
      let title = msg.title;
      let writer = msg.writer;
      let timer = msg.rate;
      let report_pdf_path = msg.report_pdf_path;
      let report = msg.report;
      let date_pay = msg.date_pay;
      let bbname = this.getCategoryName(msg.category);
      this.$router.push({
        path: "/result",
        query: {
          id: msg.id,
          title: msg.title,
          writer: msg.writer,
          timer: msg.rate,
          orderid: msg.orderid,
          report_pdf_path: msg.report_pdf_path,
          report: report,
          date_pay: msg.date_pay,
          bbname: this.getCategoryName(msg.category),
          api_orderid: msg.api_orderid,
          cid: msg.cid,
          phone: true,
        },
      });
    },
  },
};
</script>

<style scoped>
.box {
  background: #fff;
  margin-top: 0.2rem;
  padding: 0.2rem;
  box-sizing: border-box;
}
.box-title {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #ccc;
  padding: 0.1rem 0;
  font-size: 0.3rem;
}
.box-title-num {
  color: #0498fa;
  margin-left: 0.1rem;
}
.box-title-order {
  color: #ababab;
}
.box-title-status {
  color: #ee0000;
}
.box-content {
  padding: 0.2rem 0;
  border-bottom: 1px solid #ccc;
}
.box-content-order {
  display: flex;
  justify-content: space-between;
}
.box-bottom {
  font-size: 0.31rem;
  display: flex;
  align-items: center;
  padding-top: 0.15rem;
  justify-content: space-between;
}
.box-title-num {
  color: #0498fa;
  margin-left: 10rpx;
}
.box-bottom-price {
  color: #ee0000;
}
.box-content-title {
  font-size: 0.3rem;
  font-weight: bold;
  margin-bottom: 0.1rem;
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.box-content-timer {
  font-size: 0.3rem;
}
.paystyle {
  background-color: #0498fa;
  color: #fff;
  height: 0.4rem;
  line-height: 0.4rem;
  font-size: 0.3rem;
  padding: 0 0.3rem;
}
.reportstyle {
  background-color: #9acd32;
  color: #fff;
  height: 0.4rem;
  line-height: 0.4rem;
  font-size: 0.3rem;
  padding: 0 0.3rem;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  background-color: #fff;
  width: 5.5rem;
  height: 4.3rem;
  display: flex;
  border: 1px solid #ccc;
  justify-content: center;
  align-items: center;
}
.block-container {
  font-size: 0.33rem;
  line-height: 0.5rem;
}
/deep/.van-notice-bar__content {
  padding-left: 1.7rem;
}
</style>
